import { User } from '@discord/embedded-app-sdk/output/schema/types';
import { createSlice } from '@reduxjs/toolkit';

interface DiscordState {
    questStatus?: 'not_enrolled' | 'enrolled' | 'completed';
    questStatusChecked?: boolean;
    windowSize: 'minimized' | 'maximized';
    locale?: string;
    user?: User
}

const initialState: DiscordState = {
    questStatus: undefined,
    windowSize: 'maximized',
    locale: undefined,
};

export const initialDiscordState = initialState;

const discord = createSlice({
    name: 'discord',
    initialState,
    reducers: {
        setQuestStatus(state, action) {
            state.questStatus = action.payload;
            state.questStatusChecked = true;
        },
        setWindowSize(state, action) {
            state.windowSize = action.payload;
        },
        setDiscordLocale(state, action) {
            state.locale = action.payload;
        },
        setDiscordUser(state, action) {
            state.user = action.payload;
        },
    },
    extraReducers: (builder) => { },
});

export const { setQuestStatus, setWindowSize, setDiscordLocale, setDiscordUser } = discord.actions;

export const { actions: discordActions, reducer: discordReducer } = discord;

export default discordReducer;
